"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDeviceChangeObserver = addDeviceChangeObserver;
exports.bindAudioElement = bindAudioElement;
exports.bindVideoElement = bindVideoElement;
exports.chooseAudioOutput = chooseAudioOutput;
exports.chooseRemoteVideoSources = chooseRemoteVideoSources;
exports.haveVideoTileForAttendeeId = haveVideoTileForAttendeeId;
exports.listAudioInputDevices = listAudioInputDevices;
exports.listAudioOutputDevices = listAudioOutputDevices;
exports.listVideoInputDevices = listVideoInputDevices;
exports.realtimeIsLocalAudioMuted = realtimeIsLocalAudioMuted;
exports.realtimeMuteLocalAudio = realtimeMuteLocalAudio;
exports.realtimeSetCanUnmuteLocalAudio = realtimeSetCanUnmuteLocalAudio;
exports.realtimeUnmuteLocalAudio = realtimeUnmuteLocalAudio;
exports.realtimeUnsubscribeFromVolumeIndicator = realtimeUnsubscribeFromVolumeIndicator;
exports.removeDeviceChangeObserver = removeDeviceChangeObserver;
exports.setFullbandMusicMonoAudioProfile = setFullbandMusicMonoAudioProfile;
exports.setFullbandSpeechMonoAudioProfile = setFullbandSpeechMonoAudioProfile;
exports.startAudioInput = startAudioInput;
exports.startContentShare = startContentShare;
exports.startLocalVideoTile = startLocalVideoTile;
exports.startVideoInput = startVideoInput;
exports.startVideoPreviewForVideoInput = startVideoPreviewForVideoInput;
exports.stopAudioVideo = stopAudioVideo;
exports.stopContentShare = stopContentShare;
exports.stopVideoInput = stopVideoInput;
exports.stopVideoPreviewForVideoInput = stopVideoPreviewForVideoInput;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * The purpose of this file is to abstract the meetingSession.audioVideo methods and handling
 * No other methods or in depth functionality should be found here.
 */

function addDeviceChangeObserver(meetingSession, observer) {
  meetingSession.audioVideo.addDeviceChangeObserver(observer);
}
function bindAudioElement(meetingSession, audioElement) {
  meetingSession.audioVideo.bindAudioElement(audioElement);
}
function bindVideoElement(meetingSession, tileId, videoElement) {
  meetingSession.audioVideo.bindVideoElement(tileId, videoElement);
}
function chooseAudioOutput(_x, _x2) {
  return _chooseAudioOutput.apply(this, arguments);
}
function _chooseAudioOutput() {
  _chooseAudioOutput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(meetingSession, deviceId) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return meetingSession.audioVideo.chooseAudioOutput(deviceId);
        case 1:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return _chooseAudioOutput.apply(this, arguments);
}
function haveVideoTileForAttendeeId(meetingSession, attendeeId) {
  return meetingSession.audioVideo.videoTileController.haveVideoTileForAttendeeId(attendeeId);
}
function listAudioInputDevices(_x3) {
  return _listAudioInputDevices.apply(this, arguments);
}
function _listAudioInputDevices() {
  _listAudioInputDevices = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(meetingSession) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return meetingSession.audioVideo.listAudioInputDevices();
        case 1:
          return _context2.a(2, _context2.v);
      }
    }, _callee2);
  }));
  return _listAudioInputDevices.apply(this, arguments);
}
function listAudioOutputDevices(_x4) {
  return _listAudioOutputDevices.apply(this, arguments);
}
function _listAudioOutputDevices() {
  _listAudioOutputDevices = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(meetingSession) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return meetingSession.audioVideo.listAudioOutputDevices();
        case 1:
          return _context3.a(2, _context3.v);
      }
    }, _callee3);
  }));
  return _listAudioOutputDevices.apply(this, arguments);
}
function listVideoInputDevices(_x5) {
  return _listVideoInputDevices.apply(this, arguments);
}
function _listVideoInputDevices() {
  _listVideoInputDevices = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(meetingSession) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return meetingSession.audioVideo.listVideoInputDevices();
        case 1:
          return _context4.a(2, _context4.v);
      }
    }, _callee4);
  }));
  return _listVideoInputDevices.apply(this, arguments);
}
function realtimeIsLocalAudioMuted(meetingSession) {
  return meetingSession.audioVideo.realtimeIsLocalAudioMuted();
}
function realtimeMuteLocalAudio(meetingSession) {
  meetingSession.audioVideo.realtimeMuteLocalAudio();
}
function realtimeSetCanUnmuteLocalAudio(meetingSession, canUnmute) {
  meetingSession.audioVideo.realtimeSetCanUnmuteLocalAudio(canUnmute);
}
function realtimeUnmuteLocalAudio(_x6) {
  return _realtimeUnmuteLocalAudio.apply(this, arguments);
}
function _realtimeUnmuteLocalAudio() {
  _realtimeUnmuteLocalAudio = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(meetingSession) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return meetingSession.audioVideo.realtimeUnmuteLocalAudio();
        case 1:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return _realtimeUnmuteLocalAudio.apply(this, arguments);
}
function realtimeUnsubscribeFromVolumeIndicator(meetingSession, attendeeId) {
  meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
}
function removeDeviceChangeObserver(meetingSession, observer) {
  meetingSession.audioVideo.removeDeviceChangeObserver(observer);
}
function setFullbandMusicMonoAudioProfile(meetingSession) {
  meetingSession.audioVideo.setContentAudioProfile(_amazonChimeSdkJs.AudioProfile.fullbandMusicMono());
}
function startAudioInput(_x7, _x8) {
  return _startAudioInput.apply(this, arguments);
}
function _startAudioInput() {
  _startAudioInput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(meetingSession, audioDevice) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return meetingSession.audioVideo.startAudioInput(audioDevice);
        case 1:
          return _context6.a(2);
      }
    }, _callee6);
  }));
  return _startAudioInput.apply(this, arguments);
}
function startContentShare(meetingSession, stream) {
  meetingSession.audioVideo.startContentShare(stream);
}
function startLocalVideoTile(meetingSession) {
  return meetingSession.audioVideo.startLocalVideoTile();
}
function startVideoInput(_x9, _x0) {
  return _startVideoInput.apply(this, arguments);
}
function _startVideoInput() {
  _startVideoInput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(meetingSession, videoInput) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          _context7.n = 1;
          return meetingSession.audioVideo.startVideoInput(videoInput);
        case 1:
          return _context7.a(2);
      }
    }, _callee7);
  }));
  return _startVideoInput.apply(this, arguments);
}
function startVideoPreviewForVideoInput(meetingSession, videoElement) {
  meetingSession.audioVideo.startVideoPreviewForVideoInput(videoElement);
}
function stopAudioVideo(meetingSession) {
  meetingSession.audioVideo.stop();
}
function stopContentShare(meetingSession) {
  meetingSession.audioVideo.stopContentShare();
}
function stopVideoInput(_x1) {
  return _stopVideoInput.apply(this, arguments);
}
function _stopVideoInput() {
  _stopVideoInput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(meetingSession) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          _context8.n = 1;
          return meetingSession.audioVideo.stopVideoInput();
        case 1:
          return _context8.a(2);
      }
    }, _callee8);
  }));
  return _stopVideoInput.apply(this, arguments);
}
function stopVideoPreviewForVideoInput(meetingSession, videoElement) {
  meetingSession.audioVideo.stopVideoPreviewForVideoInput(videoElement);
}
function setFullbandSpeechMonoAudioProfile(meetingSession) {
  meetingSession.audioVideo.setAudioProfile(_amazonChimeSdkJs.AudioProfile.fullbandSpeechMono());
}
function chooseRemoteVideoSources(meetingSession, newVideoPreferences) {
  meetingSession.audioVideo.audioVideoController.meetingSessionContext.videoDownlinkBandwidthPolicy.chooseRemoteVideoSources(newVideoPreferences);
}